module.exports = __webpack_public_path__ + "img/scene1.b24a2e02.webp";